import React, { useEffect, useState } from "react";
import {
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  Fab,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  List,
  ListItem,
  MenuItem,
  Paper,
  Select,
  Stack,
  TableContainer,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import jwtAuthAxios from "app/services/auth/jwtAuth";
import useSwalWrapper from "@jumbo/vendors/sweetalert2/hooks";
import { LoadingButton } from "@mui/lab";
import { Add, Search } from "@mui/icons-material";
import Tableview from "app/shared/Tableview";
import ShoppingCartCheckoutSharpIcon from "@mui/icons-material/ShoppingCartCheckoutSharp";
import NoDataPlaceholder from "app/shared/NoDataPlaceholder";
import { useNavigate } from "react-router-dom";
import SearchResult from "../searchResult";
import "./invetory.css";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";
import DiamondIcon from "@mui/icons-material/Diamond";
import { ExcelGenerateAdmin } from "app/shared/ExcelGenerate/ExcelGenerateForSearch";
import useJumboAuth from "@jumbo/hooks/useJumboAuth";
import { isMobileDevice } from "app/utils/modifyArrayOfObjectsKeys";
function SingleShapeList({ setRightComp, RightComp }) {
  // const {visibleDialog} =useSelector(state => state.history)
  const [isSingle, setisSingle] = useState(true);
  const [resultView, setResultView] = useState(false);
  const [data, setData] = useState({
    SHAPE: [
      { CLASS_NAME: "ico-shp icon-round-shape", name: "ROUND" },
      { name: "OVAL", CLASS_NAME: "ico-shp icon-oval-shape" },
      { name: "PEAR", CLASS_NAME: "ico-shp icon-pear-shape" },
      { name: "MARQUISE", CLASS_NAME: "ico-shp icon-marquise-shape" },
      { name: "HEART", CLASS_NAME: "ico-shp icon-heart-shape" },
      { name: "EMERALD", CLASS_NAME: "ico-shp icon-emerald-shape" },
      { name: "CUSHION", CLASS_NAME: "ico-shp icon-cushion-shape" },
      { name: "PRINCESS", CLASS_NAME: "ico-shp icon-princess-shape" },
      { name: "RADIANT", CLASS_NAME: "ico-shp icon-radiant-shape" },
      { name: "ASSCHER", CLASS_NAME: "ico-shp icon-radiant-shape" },
      { name: "OTHER", CLASS_NAME: "ico-shp icon-others-shape" },
    ],
    COLOR: [
      { CLASS_NAME: null, name: "D" },
      { name: "E", CLASS_NAME: null },
      { name: "F", CLASS_NAME: null },
      { name: "G", CLASS_NAME: null },
      { name: "H", CLASS_NAME: null },
      { name: "I", CLASS_NAME: null },
      { name: "J", CLASS_NAME: null },
      { name: "K", CLASS_NAME: null },
    ],
    CLARITY: [
      { CLASS_NAME: null, name: "VVS1" },
      { name: "VVS2", CLASS_NAME: null },
      { name: "VS", CLASS_NAME: null },
      { name: "VS1", CLASS_NAME: null },
      { name: "VS2", CLASS_NAME: null },
      { name: "SI1", CLASS_NAME: null },
      { name: "SI2", CLASS_NAME: null },
    ],
    LAB: [
      { CLASS_NAME: null, name: "IGI" },
      { name: "GIA", CLASS_NAME: null },
      { name: "IGI(SH)", CLASS_NAME: null },
      { name: "NO-CERT", CLASS_NAME: null },
    ],
    CUT: [
      { CLASS_NAME: null, name: "ID" },
      { name: "EX", CLASS_NAME: null },
      { name: "VG", CLASS_NAME: null },
    ],
    POLISH: [
      { CLASS_NAME: null, name: "EX" },
      { name: "VG", CLASS_NAME: null },
    ],
    SYMM: [
      { CLASS_NAME: null, name: "EX" },
      { name: "VG", CLASS_NAME: null },
    ],
  });
  const [searchData, setSearchData] = useState({});

  const [stoneData, setstoneData] = useState(null);
  const [advanceSearchDialoge, setAdvanceSearchDialoge] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(50);
  const [rowCount, setRowCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const swal = useSwalWrapper();
  const navigate = useNavigate();
  const isMobile = isMobileDevice();
  useEffect(() => {
    !resultView &&
    setRightComp(
      <>
        {isMobile ? (
          <Tooltip title="Search Stone">
            <Fab
              size="small"
              variant="outlined"
              onClick={handleSearchClick}
              sx={{
                display: "flex",
                margin: "5px auto",
                mt: 3,
                ml: "auto !important",
              }}
              color="primary"
            >
              <Search />
            </Fab>
          </Tooltip>
        ) : (
          <LoadingButton
            variant="contained"
            onClick={handleSearchClick}
            sx={{
              display: "flex",
              margin: "5px auto",
              mt: 3,
              ml: "auto !important",
            }}
            color="primary"
          >
            Search
          </LoadingButton>
        )}
      </>
    );
  }, [resultView, searchData]);

  

  const stoneSearchHandler = async (page, pageSize, searchData) => {
    setLoading(true);
    await jwtAuthAxios
      .post(`search/stone?page=${page}&pageSize=${pageSize}`, searchData)
      .then((res) => {
        setResultView(res.data);
        setRowCount(res.data.total);
      })
      .catch((e) => {
        swal.fire({
          icon: "error",
          text: "Internal server Error",
        });
      });
    setLoading(false);
  };

  useEffect(() => {
    if (resultView) {
      stoneSearchHandler(page, pageSize);
    }
    // return()=>{
    //   setResultView(null)
    // }
  }, [page, pageSize]);

  const handleChangeSearchData = (type, data) => {
    let updatedTypeArray = searchData[type] ? [...searchData[type]] : []; // Create a copy or an empty array

    data.forEach((item) => {
      const index = updatedTypeArray.indexOf(item.name);
      if (index !== -1) {
        // name found in the array, remove it
        updatedTypeArray.splice(index, 1);
        // console.log(`Removed ${item.name} from the array`);
      } else {
        // name not found in the array, add it
        updatedTypeArray.push(item.name);
        // console.log(`Added ${item.name} to the array`);
      }
    });

    setSearchData({ ...searchData, [type]: updatedTypeArray }); // Update searchData[type] with the modified array
    // console.log({ type, data });
  };

  // const handlePageChange = (newPage) => {
  //   console.log('Page changed to:', newPage);
  //   setPage(newPage);
  // };

  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize?.pageSize);
    setPage(newPageSize?.page);
  };
  const handleSearchClick = () => {
    stoneSearchHandler(page, pageSize, searchData);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const {authUser}= useJumboAuth()
  return resultView ? (
    <SearchResult
      searchformData={searchData}
      setRightComp={setRightComp}
      RightComp={RightComp}
      resultView={resultView}
      fallBack={setResultView}
      page={page}
      pageSize={pageSize}
      rowCount={rowCount}
      loading={loading}
      handlePageSizeChange={handlePageSizeChange}
    />
  ) : (
    <>
      <div>
        {stoneData == null ? (
          <Paper>
            {data && (
              <List>
                 <ListItem >
                <Grid container>
                  <Grid item xl={1} lg={2} xs={12}>
                    <Typography sx={{ mt: 1, mb: 1, color: "text.secondary", fontSize: "16px", textTransform: "capitalize"}} component={"h3"} >SHAPE</Typography>
                  </Grid>
                  <Grid item lg={10} xl={12}>
                    <Stack direction={"row"} row={2.5} flexWrap={"wrap"}>
                      <Paper onClick={() => { handleChangeSearchData('SHAPE', [{ CLASS_NAME: "ico-shp icon-round-shape", name: "ROUND" }]); }} sx={{m: 0.3,px: 1,py: 0.5,width: "80px",minWidth: "65px",textAlign: "center",cursor: "pointer",color: (theme) => searchData['SHAPE'] && searchData['SHAPE'].indexOf('ROUND') != -1 ? theme.palette.primary.main : "",borderColor: (theme) => searchData['SHAPE'] && searchData['SHAPE'].indexOf('ROUND') != -1 ? theme.palette.primary.main : "", }} variant={"outlined"} > <i className="ico-shp icon-round-shape" style={{fontSize: "50px",display: "block",marginBottom: "-22px"}}></i>ROUND</Paper>
                      <Paper onClick={() => { handleChangeSearchData('SHAPE', [{ CLASS_NAME: "ico-shp icon-oval-shape", name: "OVAL" }]); }} sx={{m: 0.3,px: 1,py: 0.5,width: "80px",minWidth: "65px",textAlign: "center",cursor: "pointer",color: (theme) => searchData['SHAPE'] && searchData['SHAPE'].indexOf('OVAL') != -1 ? theme.palette.primary.main : "",borderColor: (theme) => searchData['SHAPE'] && searchData['SHAPE'].indexOf('OVAL') != -1 ? theme.palette.primary.main : "", }} variant={"outlined"} > <i className="ico-shp icon-oval-shape" style={{fontSize: "50px",display: "block",marginBottom: "-22px"}}></i>OVAL</Paper>
                      <Paper onClick={() => { handleChangeSearchData('SHAPE', [{ name: "PEAR", CLASS_NAME: "ico-shp icon-pear-shape" }]) }} sx={{m: 0.3,px: 1,py: 0.5,width: "80px",minWidth: "65px",textAlign: "center",cursor: "pointer",color: (theme) => searchData['SHAPE'] && searchData['SHAPE'].indexOf('PEAR') != -1 ? theme.palette.primary.main : "",borderColor: (theme) => searchData['SHAPE'] && searchData['SHAPE'].indexOf('PEAR') != -1 ? theme.palette.primary.main : "", }} variant={"outlined"} > <i className="ico-shp icon-pear-shape" style={{fontSize: "50px",display: "block",marginBottom: "-22px"}}></i>PEAR</Paper>
                      <Paper onClick={() => { handleChangeSearchData('SHAPE', [{ name: "MARQUISE", CLASS_NAME: "ico-shp icon-marquise-shape" }]) }} sx={{m: 0.3,px: 1,py: 0.5,width: "80px",minWidth: "65px",textAlign: "center",cursor: "pointer",color: (theme) => searchData['SHAPE'] && searchData['SHAPE'].indexOf('MARQUISE') != -1 ? theme.palette.primary.main : "",borderColor: (theme) => searchData['SHAPE'] && searchData['SHAPE'].indexOf('MARQUISE') != -1 ? theme.palette.primary.main : "", }} variant={"outlined"} > <i className="ico-shp icon-marquise-shape" style={{fontSize: "50px",display: "block",marginBottom: "-22px"}}></i>MARQUISE</Paper>
                      <Paper onClick={() => { handleChangeSearchData('SHAPE', [{ name: "HEART", CLASS_NAME: "ico-shp icon-heart-shape" }]) }} sx={{m: 0.3,px: 1,py: 0.5,width: "80px",minWidth: "65px",textAlign: "center",cursor: "pointer",color: (theme) => searchData['SHAPE'] && searchData['SHAPE'].indexOf('HEART') != -1 ? theme.palette.primary.main : "",borderColor: (theme) => searchData['SHAPE'] && searchData['SHAPE'].indexOf('HEART') != -1 ? theme.palette.primary.main : "", }} variant={"outlined"} > <i className="ico-shp icon-heart-shape" style={{fontSize: "50px",display: "block",marginBottom: "-22px"}}></i>HEART</Paper>
                      <Paper onClick={() => { handleChangeSearchData('SHAPE', [{ name: "EMERALD", CLASS_NAME: "ico-shp icon-emerald-shape" }]) }} sx={{m: 0.3,px: 1,py: 0.5,width: "80px",minWidth: "65px",textAlign: "center",cursor: "pointer",color: (theme) => searchData['SHAPE'] && searchData['SHAPE'].indexOf('EMERALD') != -1 ? theme.palette.primary.main : "",borderColor: (theme) => searchData['SHAPE'] && searchData['SHAPE'].indexOf('EMERALD') != -1 ? theme.palette.primary.main : "", }} variant={"outlined"} > <i className="ico-shp icon-emerald-shape" style={{fontSize: "50px",display: "block",marginBottom: "-22px"}}></i>EMERALD</Paper>
                      <Paper onClick={() => { handleChangeSearchData('SHAPE', [{ name: "CUSHION", CLASS_NAME: "ico-shp icon-cushion-shape" }]) }} sx={{m: 0.3,px: 1,py: 0.5,width: "80px",minWidth: "65px",textAlign: "center",cursor: "pointer",color: (theme) => searchData['SHAPE'] && searchData['SHAPE'].indexOf('CUSHION') != -1 ? theme.palette.primary.main : "",borderColor: (theme) => searchData['SHAPE'] && searchData['SHAPE'].indexOf('CUSHION') != -1 ? theme.palette.primary.main : "", }} variant={"outlined"} > <i className="ico-shp icon-cushion-shape" style={{fontSize: "50px",display: "block",marginBottom: "-22px"}}></i>CUSHION</Paper>
                      <Paper onClick={() => { handleChangeSearchData('SHAPE', [{ name: "PRINCESS", CLASS_NAME: "ico-shp icon-princess-shape" }]) }} sx={{m: 0.3,px: 1,py: 0.5,width: "80px",minWidth: "65px",textAlign: "center",cursor: "pointer",color: (theme) => searchData['SHAPE'] && searchData['SHAPE'].indexOf('PRINCESS') != -1 ? theme.palette.primary.main : "",borderColor: (theme) => searchData['SHAPE'] && searchData['SHAPE'].indexOf('PRINCESS') != -1 ? theme.palette.primary.main : "", }} variant={"outlined"} > <i className="ico-shp icon-princess-shape" style={{fontSize: "50px",display: "block",marginBottom: "-22px"}}></i>PRINCESS</Paper>
                      <Paper onClick={() => { handleChangeSearchData('SHAPE', [{ name: "RADIANT", CLASS_NAME: "ico-shp icon-radiant-shape" }]) }} sx={{m: 0.3,px: 1,py: 0.5,width: "80px",minWidth: "65px",textAlign: "center",cursor: "pointer",color: (theme) => searchData['SHAPE'] && searchData['SHAPE'].indexOf('RADIANT') != -1 ? theme.palette.primary.main : "",borderColor: (theme) => searchData['SHAPE'] && searchData['SHAPE'].indexOf('RADIANT') != -1 ? theme.palette.primary.main : "", }} variant={"outlined"} > <i className="ico-shp icon-radiant-shape" style={{fontSize: "50px",display: "block",marginBottom: "-22px"}}></i>RADIANT</Paper>
                      <Paper onClick={() => { handleChangeSearchData('SHAPE', [{ name: "ASSCHER", CLASS_NAME: "ico-shp icon-radiant-shape" }]) }} sx={{m: 0.3,px: 1,py: 0.5,width: "80px",minWidth: "65px",textAlign: "center",cursor: "pointer",color: (theme) => searchData['SHAPE'] && searchData['SHAPE'].indexOf('ASSCHER') != -1 ? theme.palette.primary.main : "",borderColor: (theme) => searchData['SHAPE'] && searchData['SHAPE'].indexOf('ASSCHER') != -1 ? theme.palette.primary.main : "", }} variant={"outlined"} > <i className="ico-shp icon-radiant-shape" style={{fontSize: "50px",display: "block",marginBottom: "-22px"}}></i>ASSCHER</Paper>
                      <Paper onClick={() => { handleChangeSearchData('SHAPE', [{ name: "OTHER", CLASS_NAME: "ico-shp icon-others-shape" }]) }} sx={{m: 0.3,px: 1,py: 0.5,width: "80px",minWidth: "65px",textAlign: "center",cursor: "pointer",color: (theme) => searchData['SHAPE'] && searchData['SHAPE'].indexOf('OTHER') != -1 ? theme.palette.primary.main : "",borderColor: (theme) => searchData['SHAPE'] && searchData['SHAPE'].indexOf('OTHER') != -1 ? theme.palette.primary.main : "", }} variant={"outlined"} > <i className="ico-shp icon-others-shape" style={{fontSize: "50px",display: "block",marginBottom: "-22px"}}></i>OTHER</Paper>                      
                    </Stack>
                  </Grid>
                </Grid>
              </ListItem>
              <Grid container>
                <Grid item lg={6} xs={12}>
                <ListItem >
                  <Grid container>
                    <Grid item xl={1} lg={2} xs={12}>
                      <Typography sx={{ mt: 1, mb: 1, color: "text.secondary", fontSize: "16px", textTransform: "capitalize" }} component={"h3"} >COLOR</Typography>
                    </Grid>
                    <Grid item lg={10} xl={12}>
                      <Stack direction={"row"} row={2.5} flexWrap={"wrap"}>
                        <Paper onClick={() => { handleChangeSearchData('COLOR', [{ name: "D", CLASS_NAME: null }]) }} sx={{ m: 0.3, px: 1, py: 0.5, width: "40px", minWidth: "40px", textAlign: "center", cursor: "pointer", color: (theme) => searchData['COLOR'] && searchData['COLOR'].indexOf('D') != -1 ? theme.palette.primary.main : "", borderColor: (theme) => searchData['COLOR'] && searchData['COLOR'].indexOf('D') != -1 ? theme.palette.primary.main : "", }} variant={"outlined"} > D</Paper>
                        <Paper onClick={() => { handleChangeSearchData('COLOR', [{ name: "E", CLASS_NAME: null }]) }} sx={{ m: 0.3, px: 1, py: 0.5, width: "40px", minWidth: "40px", textAlign: "center", cursor: "pointer", color: (theme) => searchData['COLOR'] && searchData['COLOR'].indexOf('E') != -1 ? theme.palette.primary.main : "", borderColor: (theme) => searchData['COLOR'] && searchData['COLOR'].indexOf('E') != -1 ? theme.palette.primary.main : "", }} variant={"outlined"} > E</Paper>
                        <Paper onClick={() => { handleChangeSearchData('COLOR', [{ name: "F", CLASS_NAME: null }]) }} sx={{ m: 0.3, px: 1, py: 0.5, width: "40px", minWidth: "40px", textAlign: "center", cursor: "pointer", color: (theme) => searchData['COLOR'] && searchData['COLOR'].indexOf('F') != -1 ? theme.palette.primary.main : "", borderColor: (theme) => searchData['COLOR'] && searchData['COLOR'].indexOf('F') != -1 ? theme.palette.primary.main : "", }} variant={"outlined"} > F</Paper>
                        <Paper onClick={() => { handleChangeSearchData('COLOR', [{ name: "G", CLASS_NAME: null }]) }} sx={{ m: 0.3, px: 1, py: 0.5, width: "40px", minWidth: "40px", textAlign: "center", cursor: "pointer", color: (theme) => searchData['COLOR'] && searchData['COLOR'].indexOf('G') != -1 ? theme.palette.primary.main : "", borderColor: (theme) => searchData['COLOR'] && searchData['COLOR'].indexOf('G') != -1 ? theme.palette.primary.main : "", }} variant={"outlined"} > G</Paper>
                        <Paper onClick={() => { handleChangeSearchData('COLOR', [{ name: "H", CLASS_NAME: null }]) }} sx={{ m: 0.3, px: 1, py: 0.5, width: "40px", minWidth: "40px", textAlign: "center", cursor: "pointer", color: (theme) => searchData['COLOR'] && searchData['COLOR'].indexOf('H') != -1 ? theme.palette.primary.main : "", borderColor: (theme) => searchData['COLOR'] && searchData['COLOR'].indexOf('H') != -1 ? theme.palette.primary.main : "", }} variant={"outlined"} > H</Paper>
                        <Paper onClick={() => { handleChangeSearchData('COLOR', [{ name: "I", CLASS_NAME: null }]) }} sx={{ m: 0.3, px: 1, py: 0.5, width: "40px", minWidth: "40px", textAlign: "center", cursor: "pointer", color: (theme) => searchData['COLOR'] && searchData['COLOR'].indexOf('I') != -1 ? theme.palette.primary.main : "", borderColor: (theme) => searchData['COLOR'] && searchData['COLOR'].indexOf('I') != -1 ? theme.palette.primary.main : "", }} variant={"outlined"} > I</Paper>
                        <Paper onClick={() => { handleChangeSearchData('COLOR', [{ name: "J", CLASS_NAME: null }]) }} sx={{ m: 0.3, px: 1, py: 0.5, width: "40px", minWidth: "40px", textAlign: "center", cursor: "pointer", color: (theme) => searchData['COLOR'] && searchData['COLOR'].indexOf('J') != -1 ? theme.palette.primary.main : "", borderColor: (theme) => searchData['COLOR'] && searchData['COLOR'].indexOf('J') != -1 ? theme.palette.primary.main : "", }} variant={"outlined"} > J</Paper>
                        <Paper onClick={() => { handleChangeSearchData('COLOR', [{ name: "K", CLASS_NAME: null }]) }} sx={{ m: 0.3, px: 1, py: 0.5, width: "40px", minWidth: "40px", textAlign: "center", cursor: "pointer", color: (theme) => searchData['COLOR'] && searchData['COLOR'].indexOf('K') != -1 ? theme.palette.primary.main : "", borderColor: (theme) => searchData['COLOR'] && searchData['COLOR'].indexOf('K') != -1 ? theme.palette.primary.main : "", }} variant={"outlined"} > K</Paper>
                      </Stack>
                    </Grid>
                  </Grid>
                </ListItem>
                </Grid>
                <Grid item lg={6} xs={12}>
                <ListItem >
                  <Grid container>
                    <Grid item xl={1} lg={2} xs={12}>
                      <Typography sx={{ mt: 1, mb: 1, color: "text.secondary", fontSize: "16px", textTransform: "capitalize" }} component={"h3"} >CLARITY</Typography>
                    </Grid>
                    <Grid item lg={10} xl={12}>
                      <Stack direction={"row"} row={2.5} flexWrap={"wrap"}>
                        <Paper onClick={() => { handleChangeSearchData('CLARITY', [{ name: "VVS1", CLASS_NAME: null }]) }} sx={{ m: 0.3, px: 1, py: 0.5, width: "60px", minWidth: "60px", textAlign: "center", cursor: "pointer", color: (theme) => searchData['CLARITY'] && searchData['CLARITY'].indexOf('VVS1') != -1 ? theme.palette.primary.main : "", borderColor: (theme) => searchData['CLARITY'] && searchData['CLARITY'].indexOf('VVS1') != -1 ? theme.palette.primary.main : "", }} variant={"outlined"} > VVS1</Paper>
                        <Paper onClick={() => { handleChangeSearchData('CLARITY', [{ name: "VVS2", CLASS_NAME: null }]) }} sx={{ m: 0.3, px: 1, py: 0.5, width: "60px", minWidth: "60px", textAlign: "center", cursor: "pointer", color: (theme) => searchData['CLARITY'] && searchData['CLARITY'].indexOf('VVS2') != -1 ? theme.palette.primary.main : "", borderColor: (theme) => searchData['CLARITY'] && searchData['CLARITY'].indexOf('VVS2') != -1 ? theme.palette.primary.main : "", }} variant={"outlined"} > VVS2</Paper>
                        <Paper onClick={() => { handleChangeSearchData('CLARITY', [{ name: "VS", CLASS_NAME: null }]) }} sx={{ m: 0.3, px: 1, py: 0.5, width: "60px", minWidth: "60px", textAlign: "center", cursor: "pointer", color: (theme) => searchData['CLARITY'] && searchData['CLARITY'].indexOf('VS') != -1 ? theme.palette.primary.main : "", borderColor: (theme) => searchData['CLARITY'] && searchData['CLARITY'].indexOf('VS') != -1 ? theme.palette.primary.main : "", }} variant={"outlined"} > VS</Paper>
                        <Paper onClick={() => { handleChangeSearchData('CLARITY', [{ name: "VS1", CLASS_NAME: null }]) }} sx={{ m: 0.3, px: 1, py: 0.5, width: "60px", minWidth: "60px", textAlign: "center", cursor: "pointer", color: (theme) => searchData['CLARITY'] && searchData['CLARITY'].indexOf('VS1') != -1 ? theme.palette.primary.main : "", borderColor: (theme) => searchData['CLARITY'] && searchData['CLARITY'].indexOf('VS1') != -1 ? theme.palette.primary.main : "", }} variant={"outlined"} > VS1</Paper>
                        <Paper onClick={() => { handleChangeSearchData('CLARITY', [{ name: "VS2", CLASS_NAME: null }]) }} sx={{ m: 0.3, px: 1, py: 0.5, width: "60px", minWidth: "60px", textAlign: "center", cursor: "pointer", color: (theme) => searchData['CLARITY'] && searchData['CLARITY'].indexOf('VS2') != -1 ? theme.palette.primary.main : "", borderColor: (theme) => searchData['CLARITY'] && searchData['CLARITY'].indexOf('VS2') != -1 ? theme.palette.primary.main : "", }} variant={"outlined"} > VS2</Paper>
                        <Paper onClick={() => { handleChangeSearchData('CLARITY', [{ name: "SI1", CLASS_NAME: null }]) }} sx={{ m: 0.3, px: 1, py: 0.5, width: "60px", minWidth: "60px", textAlign: "center", cursor: "pointer", color: (theme) => searchData['CLARITY'] && searchData['CLARITY'].indexOf('SI1') != -1 ? theme.palette.primary.main : "", borderColor: (theme) => searchData['CLARITY'] && searchData['CLARITY'].indexOf('SI1') != -1 ? theme.palette.primary.main : "", }} variant={"outlined"} > SI1</Paper>
                        <Paper onClick={() => { handleChangeSearchData('CLARITY', [{ name: "SI2", CLASS_NAME: null }]) }} sx={{ m: 0.3, px: 1, py: 0.5, width: "60px", minWidth: "60px", textAlign: "center", cursor: "pointer", color: (theme) => searchData['CLARITY'] && searchData['CLARITY'].indexOf('SI2') != -1 ? theme.palette.primary.main : "", borderColor: (theme) => searchData['CLARITY'] && searchData['CLARITY'].indexOf('SI2') != -1 ? theme.palette.primary.main : "", }} variant={"outlined"} > SI2</Paper>

                      </Stack>
                    </Grid>
                  </Grid>
                </ListItem>
                </Grid>
                <Grid item lg={3} xs={12}>
                <ListItem >
                  <Grid container>
                    <Grid item xl={1} lg={2} xs={12}>
                      <Typography sx={{ mt: 1, mb: 1, color: "text.secondary", fontSize: "16px", textTransform: "capitalize" }} component={"h3"} >LAB</Typography>
                    </Grid>
                    <Grid item lg={10} xl={12}>
                      <Stack direction={"row"} row={2.5} flexWrap={"wrap"}>
                        <Paper onClick={() => { handleChangeSearchData('LAB', [{ name: "IGI", CLASS_NAME: null }]) }} sx={{ m: 0.3, px: 1, py: 0.5, width: "80px", minWidth: "65px", textAlign: "center", cursor: "pointer", color: (theme) => searchData['LAB'] && searchData['LAB'].indexOf('IGI') != -1 ? theme.palette.primary.main : "", borderColor: (theme) => searchData['LAB'] && searchData['LAB'].indexOf('IGI') != -1 ? theme.palette.primary.main : "", }} variant={"outlined"} > IGI</Paper>
                        <Paper onClick={() => { handleChangeSearchData('LAB', [{ name: "GIA", CLASS_NAME: null }]) }} sx={{ m: 0.3, px: 1, py: 0.5, width: "80px", minWidth: "65px", textAlign: "center", cursor: "pointer", color: (theme) => searchData['LAB'] && searchData['LAB'].indexOf('GIA') != -1 ? theme.palette.primary.main : "", borderColor: (theme) => searchData['LAB'] && searchData['LAB'].indexOf('GIA') != -1 ? theme.palette.primary.main : "", }} variant={"outlined"} > GIA</Paper>
                        <Paper onClick={() => { handleChangeSearchData('LAB', [{ name: "IGI(SH)", CLASS_NAME: null }]) }} sx={{ m: 0.3, px: 1, py: 0.5, width: "80px", minWidth: "65px", textAlign: "center", cursor: "pointer", color: (theme) => searchData['LAB'] && searchData['LAB'].indexOf('IGI(SH)') != -1 ? theme.palette.primary.main : "", borderColor: (theme) => searchData['LAB'] && searchData['LAB'].indexOf('IGI(SH)') != -1 ? theme.palette.primary.main : "", }} variant={"outlined"} > IGI(SH)</Paper>
                        <Paper onClick={() => { handleChangeSearchData('LAB', [{ name: "NO-CERT", CLASS_NAME: null }]) }} sx={{ m: 0.3, px: 1, py: 0.5, width: "80px", minWidth: "65px", textAlign: "center", cursor: "pointer", color: (theme) => searchData['LAB'] && searchData['LAB'].indexOf('NO-CERT') != -1 ? theme.palette.primary.main : "", borderColor: (theme) => searchData['LAB'] && searchData['LAB'].indexOf('NO-CERT') != -1 ? theme.palette.primary.main : "", }} variant={"outlined"} > NO-CERT</Paper>

                      </Stack>
                    </Grid>
                  </Grid>
                </ListItem>
                
                </Grid>
                <Grid item lg={3} xs={12}>
                <ListItem >
                  <Grid container>
                    <Grid item xl={1} lg={2} xs={12}>
                      <Typography sx={{ mt: 1, mb: 1, color: "text.secondary", fontSize: "16px", textTransform: "capitalize" }} component={"h3"} >CUT</Typography>
                    </Grid>
                    <Grid item lg={10} xl={12}>
                      <Stack direction={"row"} row={2.5} flexWrap={"wrap"}>
                        <Paper onClick={() => { handleChangeSearchData('CUT', [{ name: "ID", CLASS_NAME: null }]) }} sx={{ m: 0.3, px: 1, py: 0.5, width: "80px", minWidth: "65px", textAlign: "center", cursor: "pointer", color: (theme) => searchData['CUT'] && searchData['CUT'].indexOf('ID') != -1 ? theme.palette.primary.main : "", borderColor: (theme) => searchData['CUT'] && searchData['CUT'].indexOf('ID') != -1 ? theme.palette.primary.main : "", }} variant={"outlined"} > ID</Paper>
                        <Paper onClick={() => { handleChangeSearchData('CUT', [{ name: "EX", CLASS_NAME: null }]) }} sx={{ m: 0.3, px: 1, py: 0.5, width: "80px", minWidth: "65px", textAlign: "center", cursor: "pointer", color: (theme) => searchData['CUT'] && searchData['CUT'].indexOf('EX') != -1 ? theme.palette.primary.main : "", borderColor: (theme) => searchData['CUT'] && searchData['CUT'].indexOf('EX') != -1 ? theme.palette.primary.main : "", }} variant={"outlined"} > EX</Paper>
                        <Paper onClick={() => { handleChangeSearchData('CUT', [{ name: "VG", CLASS_NAME: null }]) }} sx={{ m: 0.3, px: 1, py: 0.5, width: "80px", minWidth: "65px", textAlign: "center", cursor: "pointer", color: (theme) => searchData['CUT'] && searchData['CUT'].indexOf('VG') != -1 ? theme.palette.primary.main : "", borderColor: (theme) => searchData['CUT'] && searchData['CUT'].indexOf('VG') != -1 ? theme.palette.primary.main : "", }} variant={"outlined"} > VG</Paper>

                      </Stack>
                    </Grid>
                  </Grid>
                </ListItem>
                </Grid>
                <Grid item lg={3} xs={12}>
                <ListItem >
                  <Grid container>
                    <Grid item xl={1} lg={2} xs={12}>
                      <Typography sx={{ mt: 1, mb: 1, color: "text.secondary", fontSize: "16px", textTransform: "capitalize" }} component={"h3"} >POLISH</Typography>
                    </Grid>
                    <Grid item lg={10} xl={12}>
                      <Stack direction={"row"} row={2.5} flexWrap={"wrap"}>
                        <Paper onClick={() => { handleChangeSearchData('POLISH', [{ name: "EX", CLASS_NAME: null }]) }} sx={{ m: 0.3, px: 1, py: 0.5, width: "80px", minWidth: "65px", textAlign: "center", cursor: "pointer", color: (theme) => searchData['POLISH'] && searchData['POLISH'].indexOf('EX') != -1 ? theme.palette.primary.main : "", borderColor: (theme) => searchData['POLISH'] && searchData['POLISH'].indexOf('EX') != -1 ? theme.palette.primary.main : "", }} variant={"outlined"} > EX</Paper>
                        <Paper onClick={() => { handleChangeSearchData('POLISH', [{ name: "VG", CLASS_NAME: null }]) }} sx={{ m: 0.3, px: 1, py: 0.5, width: "80px", minWidth: "65px", textAlign: "center", cursor: "pointer", color: (theme) => searchData['POLISH'] && searchData['POLISH'].indexOf('VG') != -1 ? theme.palette.primary.main : "", borderColor: (theme) => searchData['POLISH'] && searchData['POLISH'].indexOf('VG') != -1 ? theme.palette.primary.main : "", }} variant={"outlined"} > VG</Paper>
                      </Stack>
                    </Grid>
                  </Grid>
                </ListItem>
                </Grid>
                <Grid item lg={3} xs={12}>
                <ListItem >
                  <Grid container>
                    <Grid item xl={1} lg={2} xs={12}>
                      <Typography sx={{ mt: 1, mb: 1, color: "text.secondary", fontSize: "16px", textTransform: "capitalize" }} component={"h3"} >SYMM</Typography>
                    </Grid>
                    <Grid item lg={10} xl={12}>
                      <Stack direction={"row"} row={2.5} flexWrap={"wrap"}>
                        <Paper onClick={() => { handleChangeSearchData('SYMM', [{ name: "EX", CLASS_NAME: null }]) }} sx={{ m: 0.3, px: 1, py: 0.5, width: "80px", minWidth: "65px", textAlign: "center", cursor: "pointer", color: (theme) => searchData['SYMM'] && searchData['SYMM'].indexOf('EX') != -1 ? theme.palette.primary.main : "", borderColor: (theme) => searchData['SYMM'] && searchData['SYMM'].indexOf('EX') != -1 ? theme.palette.primary.main : "", }} variant={"outlined"} > EX</Paper>
                        <Paper onClick={() => { handleChangeSearchData('SYMM', [{ name: "VG", CLASS_NAME: null }]) }} sx={{ m: 0.3, px: 1, py: 0.5, width: "80px", minWidth: "65px", textAlign: "center", cursor: "pointer", color: (theme) => searchData['SYMM'] && searchData['SYMM'].indexOf('VG') != -1 ? theme.palette.primary.main : "", borderColor: (theme) => searchData['SYMM'] && searchData['SYMM'].indexOf('VG') != -1 ? theme.palette.primary.main : "", }} variant={"outlined"} > VG</Paper>
                      </Stack>
                    </Grid>
                  </Grid>
                </ListItem>
                  </Grid>
                <Grid item lg={12} xs={12}>
                <ListItem >
                  <Grid container>
                    <Grid item xl={1} lg={2} xs={12}>
                      <Typography sx={{ mt: 1, mb: 1, color: "text.secondary", fontSize: "16px", textTransform: "capitalize" }} component={"h3"} >BRANCH</Typography>
                    </Grid>
                    <Grid item lg={10} xl={12}>
                      <Stack direction={"row"} row={2.5} flexWrap={"wrap"}>
                        {authUser?.branches?.map((_,i)=>
                        <Paper key={i} onClick={() => { handleChangeSearchData('BRANCH', [{ name: _.FL_BRANCH_CODE, CLASS_NAME: null }]) }} sx={{ m: 0.3, px: 1, py: 0.5,  minWidth: "65px", textAlign: "center", cursor: "pointer", color: (theme) => searchData['BRANCH'] && searchData['BRANCH'].indexOf( _.FL_BRANCH_CODE) != -1 ? theme.palette.primary.main : "", borderColor: (theme) => searchData['BRANCH'] && searchData['BRANCH'].indexOf( _.FL_BRANCH_CODE) != -1 ? theme.palette.primary.main : "", }} variant={"outlined"} >  {_.FL_BRANCH_NAME}</Paper>
                          )}
                      </Stack>
                    </Grid>
                  </Grid>
                </ListItem>
                </Grid>
                </Grid>
                {/* {Object.keys(data).map((sfname, index) => (
                  <ListItem key={sfname}>
                    <Grid container key={sfname}>
                      <Grid item xl={1} lg={2} xs={12}>
                        <Typography
                          sx={{
                            mt: 1,
                            mb: 1,
                            color: "text.secondary",
                            fontSize: "16px",
                            textTransform: "capitalize",
                          }}
                          component={"h3"}
                        >
                          {sfname}
                        </Typography>
                      </Grid>
                      <Grid item lg={10} xl={12}>
                        <Stack direction={"row"} row={2.5} flexWrap={"wrap"}>
                          {data[sfname].map((item) => (
                            <Paper
                              onClick={() => {
                                handleChangeSearchData(sfname, [item]);
                              }}
                              key={item.name}
                              sx={{
                                m: 0.3,
                                px: 1,
                                py: 0.5,
                                width: "80px",
                                minWidth: "65px",
                                textAlign: "center",
                                cursor: "pointer",
                                color: (theme) =>
                                  searchData[sfname] &&
                                  searchData[sfname].indexOf(item.name) != -1
                                    ? theme.palette.primary.main
                                    : "",
                                borderColor: (theme) =>
                                  searchData[sfname] &&
                                  searchData[sfname].indexOf(item.name) != -1
                                    ? theme.palette.primary.main
                                    : "",
                              }}
                              variant={"outlined"}
                            >
                              {item.CLASS_NAME && (
                                <i
                                  className={item.CLASS_NAME}
                                  style={{
                                    fontSize: "50px",
                                    display: "block",
                                    marginBottom: "-22px",
                                  }}
                                ></i>
                              )}
                              {item.name}
                            </Paper>
                          ))}
                        </Stack>
                      </Grid>
                    </Grid>
                  </ListItem>
                ))} */}
                <ListItem>
                  <Grid container>
                    <Grid item xl={1} lg={2} sx={3}>
                      <Typography
                        sx={{
                          mt: 1,
                          color: "text.secondary",
                          fontSize: "16px",
                          textTransform: "capitalize",
                        }}
                        component={"h3"}
                      >
                        Carats
                      </Typography>
                    </Grid>
                    <Grid item lg={5} xl={11}>
                      <Grid container spacing={2}>
                        <Grid item md={2} xs={6}>
                          <TextField
                            defaultValue={searchData.FromCarate}
                            size="small"
                            onInput={(e) =>
                              setSearchData({
                                ...searchData,
                                FromCarate: e.target.value,
                              })
                            }
                            type="number"
                            min={"0"}
                            id="FromCarate"
                            label="From Carate"
                            variant="outlined"
                          />
                        </Grid>
                        <Grid item md={2} xs={6}>
                          <TextField
                            size="small"
                            defaultValue={searchData.ToCarate}
                            type="number"
                            onInput={(e) =>
                              setSearchData({
                                ...searchData,
                                ToCarate: e.target.value,
                              })
                            }
                            min={"0"}
                            id="To Carate"
                            label="To Carate"
                            variant="outlined"
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </ListItem>
                <ListItem>
                  <Grid container>
                    <Grid item xl={1} lg={2} sx={3}>
                      <Typography
                        onInput={(e) =>
                          setSearchData({
                            ...searchData,
                            stoneCert: e.target.value,
                          })
                        }
                        sx={{
                          mt: 1,
                          color: "text.secondary",
                          fontSize: "16px",
                          textTransform: "capitalize",
                        }}
                        component={"h3"}
                      >
                        Stone /cert no.
                      </Typography>
                    </Grid>
                    <Grid item lg={5} xs={12}>
                      <Grid container spacing={2}>
                        <Grid item lg={5} xs={12}>
                          <TextField
                            fullWidth
                            defaultValue={searchData.stoneCert}
                            onInput={(e) =>
                              setSearchData({
                                ...searchData,
                                stoneCert: e.target.value,
                              })
                            }
                            size="small"
                            id="Stone-certno"
                            label="Stone /cert no."
                            variant="outlined"
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </ListItem>
                {/* <Button sx={{ ml: 3, mt: 3 }} variant='text' onClick={() => setAdvanceSearchDialoge(true)} startIcon={<Add />}>Advance Search</Button> */}
                <Grid container sx={{ xs: { px: 2 } }}>
                  <Grid item lg={11} xl={6}>
                    <Button
                      sx={{ ml: 3, mt: 3 }}
                      variant={"outlined"}
                      onClick={() => setAdvanceSearchDialoge(true)}
                      startIcon={<Add />}
                    >
                      Advance Search
                    </Button>
                  </Grid>
                  <Grid item lg={12} xl={6} sx={{ xs: { px: 3 } }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={searchData?.Available}
                          onChange={(e) =>
                            setSearchData({
                              ...searchData,
                              Available: e.target.checked,
                            })
                          }
                          name="available"
                        />
                      }
                      sx={{ ml: 3 }}
                      label="Available"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={searchData?.METALTYPEemo}
                          onChange={(e) =>
                            setSearchData({
                              ...searchData,
                              Memo: e.target.checked,
                            })
                          }
                          name="memo"
                        />
                      }
                      label="Memo"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={searchData?.Hold}
                          onChange={(e) =>
                            setSearchData({
                              ...searchData,
                              Hold: e.target.checked,
                            })
                          }
                          name="hold"
                        />
                      }
                      label="Hold"
                    />
                  </Grid>
                </Grid>
                <ListItem>
                  <Grid container>
                    <LoadingButton
                      variant="contained"
                      onClick={handleSearchClick}
                      sx={{ display: "flex", margin: "2px auto" }}
                      color="primary"
                    >
                      Search
                    </LoadingButton>
                  </Grid>
                </ListItem>
              </List>
            )}
          </Paper>
        ) : (
          <>
            {stoneData && stoneData.length > 0 ? (
              <Tableview body={stoneData} />
            ) : (
              <NoDataPlaceholder />
            )}
          </>
        )}
        <Dialog
          open={advanceSearchDialoge}
          onClose={() => setAdvanceSearchDialoge(false)}
        >
          <DialogTitle>Advance Search</DialogTitle>
          <DialogContent>
            {/* <DialogContentText> */}
            <ListItem>
              <Grid container>
                <Grid item sx={12}>
                  <Typography
                    sx={{
                      mt: 1,
                      color: "text.secondary",
                      fontSize: "16px",
                      textTransform: "capitalize",
                    }}
                    component={"h3"}
                  >
                    Table %
                  </Typography>
                </Grid>
                <Grid item xl={12}>
                  <Grid container spacing={1}>
                    <Grid item xs={6}>
                      <TextField
                        size="small"
                        defaultValue={searchData.FromTable_per}
                        onInput={(e) =>
                          setSearchData({
                            ...searchData,
                            FromTable_per: e.target.value,
                          })
                        }
                        type="number"
                        min={"0"}
                        id="FromTable_per"
                        label="From Table"
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        size="small"
                        type="number"
                        defaultValue={searchData.ToTable_per}
                        onInput={(e) =>
                          setSearchData({
                            ...searchData,
                            ToTable_per: e.target.value,
                          })
                        }
                        min={"0"}
                        id="ToTable_per"
                        label="To Table"
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </ListItem>
            <ListItem>
              <Grid container>
                <Grid item sx={12}>
                  <Typography
                    sx={{
                      mt: 1,
                      color: "text.secondary",
                      fontSize: "16px",
                      textTransform: "capitalize",
                    }}
                    component={"h3"}
                  >
                    Depth %
                  </Typography>
                </Grid>
                <Grid item xl={12}>
                  <Grid container spacing={1}>
                    <Grid item xs={6}>
                      <TextField
                        size="small"
                        defaultValue={searchData.FromDepth_per}
                        onInput={(e) =>
                          setSearchData({
                            ...searchData,
                            FromDepth_per: e.target.value,
                          })
                        }
                        type="number"
                        min={"0"}
                        id="FromDepth_per"
                        label="From Depth"
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        size="small"
                        type="number"
                        defaultValue={searchData.ToDepth_per}
                        onInput={(e) =>
                          setSearchData({
                            ...searchData,
                            ToDepth_per: e.target.value,
                          })
                        }
                        min={"0"}
                        id="ToDepth_per"
                        label="To Depth"
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </ListItem>
            <ListItem>
              <Grid container>
                <Grid item sx={12}>
                  <Typography
                    sx={{
                      mt: 1,
                      color: "text.secondary",
                      fontSize: "16px",
                      textTransform: "capitalize",
                    }}
                    component={"h3"}
                  >
                    Ratio
                  </Typography>
                </Grid>
                <Grid item xl={12}>
                  <Grid container spacing={1}>
                    <Grid item xs={6}>
                      <TextField
                        size="small"
                        defaultValue={searchData.FromRatio}
                        onInput={(e) =>
                          setSearchData({
                            ...searchData,
                            FromRatio: e.target.value,
                          })
                        }
                        type="number"
                        min={"0"}
                        id="FromRatio"
                        label="From Ratio"
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        size="small"
                        defaultValue={searchData.ToRatio}
                        type="number"
                        onInput={(e) =>
                          setSearchData({
                            ...searchData,
                            ToRatio: e.target.value,
                          })
                        }
                        min={"0"}
                        id="ToRatio"
                        label="To Ratio"
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>
                  <LoadingButton
                    variant="contained"
                    onClick={handleSearchClick}
                    sx={{ display: "flex", margin: "5px auto", mt: 3 }}
                    color="primary"
                  >
                    Search
                  </LoadingButton>
                </Grid>
              </Grid>
            </ListItem>
            {/* </DialogContentText> */}
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
}
function ParcelShapeList({ setRightComp }) {
  const [isSingle, setisSingle] = useState(true);
  const [resultView, setResultView] = useState(false);

  const [data, setData] = useState({
    SHAPE: [
      { CLASS_NAME: "ico-shp icon-round-shape", name: "ROUND" },
      { name: "OVAL", CLASS_NAME: "ico-shp icon-oval-shape" },
      { name: "PEAR", CLASS_NAME: "ico-shp icon-pear-shape" },
      { name: "MARQUISE", CLASS_NAME: "ico-shp icon-marquise-shape" },
      { name: "HEART", CLASS_NAME: "ico-shp icon-heart-shape" },
      { name: "EMERALD", CLASS_NAME: "ico-shp icon-emerald-shape" },
      { name: "CUSHION", CLASS_NAME: "ico-shp icon-cushion-shape" },
      { name: "PRINCESS", CLASS_NAME: "ico-shp icon-princess-shape" },
      { name: "RADIANT", CLASS_NAME: "ico-shp icon-radiant-shape" },
      { name: "BAGUETTE", CLASS_NAME: "ico-shp icon-baguette-shape" },
      { name: "OTHERS", CLASS_NAME: "ico-shp icon-others-shape" },
    ],
    CARAT: [
      { CLASS_NAME: null, name: "-2" },
      { name: "+2-6.5", CLASS_NAME: null },
      { name: "+6.5-11", CLASS_NAME: null },
      { name: "+11-14", CLASS_NAME: null },
      { name: "1/10", CLASS_NAME: null },
      { name: "1/6", CLASS_NAME: null },
      { name: "1/5", CLASS_NAME: null },
      { name: "1/4", CLASS_NAME: null },
      { name: "1/3", CLASS_NAME: null },
      { name: "3/8", CLASS_NAME: null },
      { name: "1/2", CLASS_NAME: null },
      { name: "3/4", CLASS_NAME: null },
      { name: "None", CLASS_NAME: null },
      { name: "+7-10", CLASS_NAME: null },
      { name: "1-1.49", CLASS_NAME: null },
    ],
    COLOR: [
      { CLASS_NAME: null, name: "G+" },
      { name: "F.I.BLUE", CLASS_NAME: null },
    ],
    CLARITY: [
      { CLASS_NAME: null, name: "VS+" },
      { name: "SI+", CLASS_NAME: null },
    ],
  });
  const [searchData, setSearchData] = useState({});
  const [stoneData, setstoneData] = useState(null);
  const [advanceSearchDialoge, setAdvanceSearchDialoge] = useState(false);
  const isMobile = isMobileDevice();
  const swal = useSwalWrapper();
  const navigate = useNavigate();
  // useEffect(() => {
  //   jwtAuthAxios.get('search/parmas').then(res => {
  //     console.log(res.data.data);
  //     setData(res.data.data)
  //   }

  //   ).catch(e => {
  //     swal.fire({
  //       icon: 'error',
  //       text: 'Internal server Error',
  //     });
  //   })
  // }, [])
  const stoneSearchHandler = async () => {
    // if(searchData.SHAPE){
    await jwtAuthAxios
      .post("search/bulk/stone", searchData)
      .then((res) => {
        // console.log(res.data.data);
        setResultView(res.data.result);
        // console.log(res.data.result);
        // navigate('/search-result/'+res.data.SearchId)
        // setstoneData(res.data.data)
        // setData(res.data.data)
      })
      .catch((e) => {
        swal.fire({
          icon: "error",
          text: "Internal server Error",
        });
      });

    // }
    // /else{
    //   swal.fire({
    //     icon: 'error',
    //     text: 'Please Select Shape',
    //   });
    // }///////

    // console.log(searchData);
  };
  useEffect(() => {
    // console.log(isMobile);
    !resultView &&
      setRightComp(
        <>
          {isMobile ? (
            <Tooltip title="Search Stone">
              <Fab
                size="small"
                variant="outlined"
                onClick={stoneSearchHandler}
                sx={{
                  display: "flex",
                  margin: "5px auto",
                  mt: 3,
                  ml: "auto !important",
                }}
                color="primary"
              >
                <Search />
              </Fab>
            </Tooltip>
          ) : (
            <LoadingButton
              variant="contained"
              onClick={stoneSearchHandler}
              sx={{
                display: "flex",
                margin: "5px auto",
                mt: 3,
                ml: "auto !important",
              }}
              color="primary"
            >
              Search
            </LoadingButton>
          )}
        </>
      );
  }, [resultView, searchData]);
  const handleChangeSearchData = (type, data) => {
    let updatedTypeArray = searchData[type] ? [...searchData[type]] : []; // Create a copy or an empty array

    data.forEach((item) => {
      const index = updatedTypeArray.indexOf(item.name);
      if (index !== -1) {
        // name found in the array, remove it
        updatedTypeArray.splice(index, 1);
        // console.log(`Removed ${item.name} from the array`);
      } else {
        // name not found in the array, add it
        updatedTypeArray.push(item.name);
        // console.log(`Added ${item.name} to the array`);
      }
    });

    setSearchData({ ...searchData, [type]: updatedTypeArray }); // Update searchData[type] with the modified array
    // console.log({ type, data });
  };
  return resultView ? (
    <ParcelResultView
      setRightComp={setRightComp}
      ResultData={resultView}
      fallBack={setResultView}
    />
  ) : (
    <>
      <div>
        {stoneData == null ? (
          <Paper>
            {data && (
              <List>
                {Object.keys(data).map((sfname, index) => (
                  <ListItem key={sfname}>
                    <Grid container key={sfname}>
                      <Grid item xl={1} lg={2} xs={12}>
                        <Typography
                          sx={{
                            mt: 1,
                            color: "text.secondary",
                            fontSize: "16px",
                            textTransform: "capitalize",
                          }}
                          component={"h3"}
                        >
                          {sfname}
                        </Typography>
                      </Grid>
                      <Grid item lg={10} xl={11}>
                        <Stack direction={"row"} row={2.5} flexWrap={"wrap"}>
                          {data[sfname].map((item) => (
                            <Paper
                              onClick={() => {
                                handleChangeSearchData(sfname, [item]);
                              }}
                              key={item.name}
                              sx={{
                                m: 0.3,
                                px: 1,
                                py: 0.5,
                                textAlign: "center",
                                width: "80px",
                                cursor: "pointer",
                                color: (theme) =>
                                  searchData[sfname] &&
                                  searchData[sfname].indexOf(item.name) != -1
                                    ? theme.palette.primary.main
                                    : "",
                                borderColor: (theme) =>
                                  searchData[sfname] &&
                                  searchData[sfname].indexOf(item.name) != -1
                                    ? theme.palette.primary.main
                                    : "",
                              }}
                              variant={"outlined"}
                            >
                              {item.CLASS_NAME && (
                                <i
                                  className={item.CLASS_NAME}
                                  style={{
                                    fontSize: "50px",
                                    display: "block",
                                    marginBottom: "-22px",
                                  }}
                                ></i>
                              )}
                              {item.name}
                            </Paper>
                          ))}
                        </Stack>
                      </Grid>
                    </Grid>
                  </ListItem>
                ))}
                {/* <ListItem>
            <Grid container >
              <Grid item xl={1} lg={2} sx={3}>
                <Typography sx={{ mt: 1, color: "text.secondary", fontSize: '16px', textTransform: 'capitalize' }} component={'h3'}>Carats</Typography>
              </Grid>
              <Grid item lg={5} xl={11}>
                <Grid container spacing={2}>
                  <Grid item xs={2}>
                    <TextField defaultValue={searchData.FromCarate} size='small' onInput={e => setSearchData({ ...searchData, FromCarate: e.target.value })} type='number' min={'0'} id="FromCarate" label="From Carate" variant="outlined" />
                  </Grid>
                  <Grid item xs={2}>
                    <TextField size='small' defaultValue={searchData.ToCarate} type='number' onInput={e => setSearchData({ ...searchData, ToCarate: e.target.value })} min={'0'} id="To Carate" label="To Carate" variant="outlined" />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </ListItem> */}
                <ListItem>
                  <Grid container>
                    <Grid item xl={1} lg={2} xs={12}>
                      <Typography
                        onInput={(e) =>
                          setSearchData({
                            ...searchData,
                            stoneCert: e.target.value,
                          })
                        }
                        sx={{
                          mt: 1,
                          color: "text.secondary",
                          fontSize: "16px",
                          textTransform: "capitalize",
                        }}
                        component={"h3"}
                      >
                        Lot no.
                      </Typography>
                    </Grid>
                    <Grid item lg={5} xs={11}>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <TextField
                            defaultValue={searchData.stoneCert}
                            onInput={(e) =>
                              setSearchData({
                                ...searchData,
                                stoneCert: e.target.value,
                              })
                            }
                            size="small"
                            id="Stone-certno"
                            label="Stone /cert no."
                            variant="outlined"
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item lg={11} xl={6}>
                      <Button
                        sx={{ ml: 3, mt: 3 }}
                        variant="text"
                        onClick={() => setAdvanceSearchDialoge(true)}
                        startIcon={<Add />}
                      >
                        Advance Search
                      </Button>
                    </Grid>
                    {/* <Grid item lg={12} xl={6}>
                <FormControlLabel
                  control={<Checkbox checked={searchData?.available} onChange={(e) => setSearchData({ ...searchData, Available: e.target.checked })} name="available" />}
                  label="Available"
                />
                <FormControlLabel
                  control={<Checkbox checked={searchData?.memo} onChange={(e) => setSearchData({ ...searchData, Memo: e.target.checked })} name="memo" />}
                  label="Memo"
                />
                <FormControlLabel
                  control={<Checkbox checked={searchData?.hold} onChange={(e) => setSearchData({ ...searchData, Hold: e.target.checked })} name="hold" />}
                  label="Hold"
                />
              </Grid> */}
                  </Grid>
                </ListItem>
                <ListItem>
                  <Grid container>
                    <LoadingButton
                      variant="contained"
                      onClick={stoneSearchHandler}
                      sx={{ display: "flex", margin: "2px auto" }}
                      color="primary"
                    >
                      Search
                    </LoadingButton>
                  </Grid>
                </ListItem>
              </List>
            )}
          </Paper>
        ) : (
          <>
            {stoneData && stoneData.length > 0 ? (
              <Tableview body={stoneData} />
            ) : (
              <NoDataPlaceholder />
            )}
          </>
        )}
        <Dialog
          open={advanceSearchDialoge}
          onClose={() => setAdvanceSearchDialoge(false)}
        >
          <DialogTitle>Advance Search</DialogTitle>
          <DialogContent>
            {/* <DialogContentText> */}
            <ListItem>
              <Grid container>
                <Grid item sx={12}>
                  <Typography
                    sx={{
                      mt: 1,
                      color: "text.secondary",
                      fontSize: "16px",
                      textTransform: "capitalize",
                    }}
                    component={"h3"}
                  >
                    Table %
                  </Typography>
                </Grid>
                <Grid item xl={12}>
                  <Grid container spacing={1}>
                    <Grid item xs={6}>
                      <TextField
                        size="small"
                        defaultValue={searchData.FromTable_per}
                        onInput={(e) =>
                          setSearchData({
                            ...searchData,
                            FromTable_per: e.target.value,
                          })
                        }
                        type="number"
                        min={"0"}
                        id="FromTable_per"
                        label="From Table"
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        size="small"
                        type="number"
                        defaultValue={searchData.ToTable_per}
                        onInput={(e) =>
                          setSearchData({
                            ...searchData,
                            ToTable_per: e.target.value,
                          })
                        }
                        min={"0"}
                        id="ToTable_per"
                        label="To Table"
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </ListItem>
            <ListItem>
              <Grid container>
                <Grid item sx={12}>
                  <Typography
                    sx={{
                      mt: 1,
                      color: "text.secondary",
                      fontSize: "16px",
                      textTransform: "capitalize",
                    }}
                    component={"h3"}
                  >
                    Depth %
                  </Typography>
                </Grid>
                <Grid item xl={12}>
                  <Grid container spacing={1}>
                    <Grid item xs={6}>
                      <TextField
                        size="small"
                        defaultValue={searchData.FromDepth_per}
                        onInput={(e) =>
                          setSearchData({
                            ...searchData,
                            FromDepth_per: e.target.value,
                          })
                        }
                        type="number"
                        min={"0"}
                        id="FromDepth_per"
                        label="From Depth"
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        size="small"
                        type="number"
                        defaultValue={searchData.ToDepth_per}
                        onInput={(e) =>
                          setSearchData({
                            ...searchData,
                            ToDepth_per: e.target.value,
                          })
                        }
                        min={"0"}
                        id="ToDepth_per"
                        label="To Depth"
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </ListItem>
            <ListItem>
              <Grid container>
                <Grid item sx={12}>
                  <Typography
                    sx={{
                      mt: 1,
                      color: "text.secondary",
                      fontSize: "16px",
                      textTransform: "capitalize",
                    }}
                    component={"h3"}
                  >
                    Ratio
                  </Typography>
                </Grid>
                <Grid item xl={12}>
                  <Grid container spacing={1}>
                    <Grid item xs={6}>
                      <TextField
                        size="small"
                        defaultValue={searchData.FromRatio}
                        onInput={(e) =>
                          setSearchData({
                            ...searchData,
                            FromRatio: e.target.value,
                          })
                        }
                        type="number"
                        min={"0"}
                        id="FromRatio"
                        label="From Ratio"
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        size="small"
                        defaultValue={searchData.ToRatio}
                        type="number"
                        onInput={(e) =>
                          setSearchData({
                            ...searchData,
                            ToRatio: e.target.value,
                          })
                        }
                        min={"0"}
                        id="ToRatio"
                        label="To Ratio"
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>
                  <LoadingButton
                    variant="contained"
                    onClick={stoneSearchHandler}
                    sx={{ display: "flex", margin: "5px auto", mt: 3 }}
                    color="primary"
                  >
                    Search
                  </LoadingButton>
                </Grid>
              </Grid>
            </ListItem>
            {/* </DialogContentText> */}
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
}

function Jewelry({ setRightComp }) {
  const [resultView, setResultView] = useState(false);
  const [data, setData] = useState({
    CATEGORY: [
      { name: "EARRING", CLASS_NAME: "ico-shp icon-oval-shape" },
      { name: "NECKLACE", CLASS_NAME: "ico-shp icon-pear-shape" },
      { name: "RING", CLASS_NAME: "ico-shp icon-marquise-shape" },
      { name: "BRACELET", CLASS_NAME: "ico-shp icon-heart-shape" },
      { name: "ANKLET", CLASS_NAME: "ico-shp icon-emerald-shape" },
      { name: "BEADS", CLASS_NAME: "ico-shp icon-cushion-shape" },
      { name: "CHATELAINE", CLASS_NAME: "ico-shp icon-princess-shape" },
      { name: "CUFFLINK", CLASS_NAME: "ico-shp icon-radiant-shape" },
      { name: "OTHER", CLASS_NAME: "ico-shp icon-radiant-shape" },
    ],
    METALTYPE: [
      { name: "GOLD", CLASS_NAME: null },
      { name: "SLIVER", CLASS_NAME: null },
      { name: "PLATINUM", CLASS_NAME: null },
    ],
  });
  const [searchData, setSearchData] = useState({});
  const [stoneData, setstoneData] = useState(null);

  const swal = useSwalWrapper();
  const navigate = useNavigate();
  const isMobile = isMobileDevice();

  useEffect(() => {
    !resultView &&
      setRightComp(
        <>
          {isMobile ? (
            <Tooltip title="Search Stone">
              <Fab
                size="small"
                variant="outlined"
                onClick={stoneSearchHandler}
                sx={{
                  display: "flex",
                  margin: "5px auto",
                  mt: 3,
                  ml: "auto !important",
                }}
                color="primary"
              >
                <Search />
              </Fab>
            </Tooltip>
          ) : (
            <LoadingButton
              variant="contained"
              onClick={stoneSearchHandler}
              sx={{
                display: "flex",
                margin: "5px auto",
                mt: 3,
                ml: "auto !important",
              }}
              color="primary"
            >
              Search
            </LoadingButton>
          )}
        </>
      );
  }, [resultView, searchData]);

  const stoneSearchHandler = async () => {
    await jwtAuthAxios
      .post("search/jewel", searchData)
      .then((res) => {
        setResultView(res.data);
      })
      .catch((e) => {
        swal.fire({
          icon: "error",
          text: "Internal server Error",
        });
      });
  };
  const handleChangeSearchData = (type, data) => {
    let updatedTypeArray = searchData[type] ? [...searchData[type]] : [];

    data.forEach((item) => {
      const index = updatedTypeArray.indexOf(item.name);
      if (index !== -1) {
        updatedTypeArray.splice(index, 1);
      } else {
        updatedTypeArray.push(item.name);
      }
    });

    setSearchData({ ...searchData, [type]: updatedTypeArray });
  };

  return resultView?.result ? (
    <JewelryResultView
      setRightComp={setRightComp}
      ResultData={resultView?.result}
      fallBack={setResultView}
    />
  ) : (
    <>
      <div>
        {stoneData == null ? (
          <Paper>
            {data && (
              <List>
                {Object.keys(data).map((sfname, index) => (
                  <ListItem key={sfname}>
                    <Grid container key={sfname}>
                      <Grid item xl={1} lg={2} xs={12}>
                        <Typography
                          sx={{
                            mt: 1,
                            color: "text.secondary",
                            fontSize: "16px",
                            textTransform: "capitalize",
                          }}
                          component={"h3"}
                        >
                          {sfname}
                        </Typography>
                      </Grid>
                      <Grid item lg={10} xl={11}>
                        <Stack direction={"row"} row={2.5} flexWrap={"wrap"}>
                          {data[sfname].map((item) => (
                            <Paper
                              onClick={() => {
                                handleChangeSearchData(sfname, [item]);
                              }}
                              key={item.name}
                              sx={{
                                m: 0.3,
                                px: 1,
                                py: 0.5,
                                textAlign: "center",
                                width: "80px",
                                cursor: "pointer",
                                color: (theme) =>
                                  searchData[sfname] &&
                                  searchData[sfname].indexOf(item.name) != -1
                                    ? theme.palette.primary.main
                                    : "",
                                borderColor: (theme) =>
                                  searchData[sfname] &&
                                  searchData[sfname].indexOf(item.name) != -1
                                    ? theme.palette.primary.main
                                    : "",
                              }}
                              variant={"outlined"}
                            >
                              {item?.CLASS_NAME && (
                                <img
                                  src={`/images/svgs/${item.name}.svg`}
                                  style={{
                                    width: "50%",
                                    height: "50%",
                                    objectFit: "contain",
                                  }}
                                />
                              )}
                              {item.name}
                            </Paper>
                          ))}
                        </Stack>
                      </Grid>
                    </Grid>
                  </ListItem>
                ))}
                <ListItem>
                  <Grid container>
                    <Grid item xl={1} lg={2} sx={3}>
                      <Typography
                        onInput={(e) =>
                          setSearchData({
                            ...searchData,
                            ITEMNO: e.target.value,
                          })
                        }
                        sx={{
                          mt: 1,
                          color: "text.secondary",
                          fontSize: "16px",
                          textTransform: "capitalize",
                        }}
                        component={"h3"}
                      >
                        ITEM NO.
                      </Typography>
                    </Grid>
                    <Grid item lg={5} xs={12}>
                      <Grid container spacing={2}>
                        <Grid item lg={5} xs={12}>
                          <TextField
                            fullWidth
                            defaultValue={searchData.ITEMNO}
                            onInput={(e) =>
                              setSearchData({
                                ...searchData,
                                ITEMNO: e.target.value,
                              })
                            }
                            size="small"
                            id="Stone-certno"
                            label="Item No."
                            variant="outlined"
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </ListItem>
                <ListItem>
                  <Grid container>
                    <Grid item xl={1} lg={2} sx={3}>
                      <Typography
                        sx={{
                          mt: 1,
                          color: "text.secondary",
                          fontSize: "16px",
                          textTransform: "capitalize",
                        }}
                        component={"h3"}
                      >
                        GR WT
                      </Typography>
                    </Grid>
                    <Grid item lg={5} xl={11}>
                      <Grid container spacing={2}>
                        <Grid item md={2} xs={6}>
                          <TextField
                            defaultValue={searchData.FR_GR_WT}
                            size="small"
                            onInput={(e) => {
                              setSearchData({
                                ...searchData,
                                FR_GR_WT: e.target.value,
                              });
                            }}
                            type="number"
                            min={"0"}
                            id="FR_GR_WT"
                            label="From"
                            variant="outlined"
                          />
                        </Grid>
                        <Grid item md={2} xs={6}>
                          <TextField
                            size="small"
                            defaultValue={searchData.TO_GR_WT}
                            type="number"
                            onInput={(e) =>
                              setSearchData({
                                ...searchData,
                                TO_GR_WT: e.target.value,
                              })
                            }
                            min={"0"}
                            id="TO_GR_WT"
                            label="To"
                            variant="outlined"
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </ListItem>
                <ListItem>
                  <Grid container>
                    <Grid item xl={1} lg={2} sx={3}>
                      <Typography
                        sx={{
                          mt: 1,
                          color: "text.secondary",
                          fontSize: "16px",
                          textTransform: "capitalize",
                        }}
                        component={"h3"}
                      >
                        NE WT
                      </Typography>
                    </Grid>
                    <Grid item lg={5} xl={11}>
                      <Grid container spacing={2}>
                        <Grid item md={2} xs={6}>
                          <TextField
                            defaultValue={searchData.FR_NE_WT}
                            size="small"
                            onInput={(e) =>
                              setSearchData({
                                ...searchData,
                                FR_NE_WT: e.target.value,
                              })
                            }
                            type="number"
                            min={"0"}
                            id="FR_NE_WT"
                            label="From"
                            variant="outlined"
                          />
                        </Grid>
                        <Grid item md={2} xs={6}>
                          <TextField
                            size="small"
                            defaultValue={searchData.TO_NE_WT}
                            type="number"
                            onInput={(e) =>
                              setSearchData({
                                ...searchData,
                                TO_NE_WT: e.target.value,
                              })
                            }
                            min={"0"}
                            id="TO_NE_WT"
                            label="To"
                            variant="outlined"
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </ListItem>

                <ListItem></ListItem>
                <Grid container sx={{ xs: { px: 1 } }}>
                  <Grid item lg={12} xl={12} sx={{ xs: { px: 3 } }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={searchData?.Available}
                          onChange={(e) =>
                            setSearchData({
                              ...searchData,
                              Available: e.target.checked,
                            })
                          }
                          name="available"
                        />
                      }
                      sx={{ ml: 3 }}
                      label="Available"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={searchData?.Memo}
                          onChange={(e) =>
                            setSearchData({
                              ...searchData,
                              Memo: e.target.checked,
                            })
                          }
                          name="memo"
                        />
                      }
                      label="Memo"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={searchData?.Hold}
                          onChange={(e) =>
                            setSearchData({
                              ...searchData,
                              Hold: e.target.checked,
                            })
                          }
                          name="hold"
                        />
                      }
                      label="Hold"
                    />
                  </Grid>
                </Grid>
                <ListItem>
                  <Grid container>
                    <LoadingButton
                      variant="contained"
                      onClick={stoneSearchHandler}
                      sx={{ display: "flex", margin: "2px auto" }}
                      color="primary"
                    >
                      Search
                    </LoadingButton>
                  </Grid>
                </ListItem>
              </List>
            )}
          </Paper>
        ) : (
          <>
            {stoneData && stoneData.length > 0 ? (
              <Tableview body={stoneData} />
            ) : (
              <NoDataPlaceholder />
            )}
          </>
        )}
      </div>
    </>
  );
}

const ParcelResultView = ({ setRightComp, ResultData, fallBack }) => {
  const [userParty, setUserParty] = useState(null);
  // const [selectedStoneDetails, setSelectedStoneDetails] = useState({ pcs: 0, cts: 0, rap: 0, disc: 0 })
  const [userSelectedParty, setUserSelectedParty] = useState(null);
  const [BLOADER, setBLOADER] = useState(false);
  const [SelectedStone, setSelectedStone] = useState([]);
  const [SelectedStoneData, setSelectedStoneData] = useState([]);
  const swal = useSwalWrapper();
  const navigate = useNavigate();
  const { menuObject } = useJumboAuth();
  const columns = [
    { field: "FL_MAIN_LOT", flex: 1, headerName: "Main Lot" },
    { field: "FL_SUB_LOT", flex: 1, headerName: "Sub Lot no." },
    { field: "FL_COLOR", flex: 1, headerName: "Color" },
    { field: "FL_CLARITY", flex: 1, headerName: "Clarity" },
    { field: "FL_CARATS", flex: 1, type: "number", headerName: "CTS" },
    {
      field: "FL_ASK_AMT",
      flex: 1,
      type: "number",
      headerName: "Ask. Rate/cts",
      renderCell: (params) => Number(params.value)?.toFixed(2),
    },
    {
      field: "FL_GREEN_AMT",
      flex: 1,
      type: "number",
      headerName: "Green Rate/cts",
      renderCell: (params) => Number(params.value)?.toFixed(2),
    },
    {
      field: "FL_RED_AMT",
      flex: 1,
      type: "number",
      headerName: "Red Rate/cts",
      renderCell: (params) => Number(params.value)?.toFixed(2),
    },
  ];

  useEffect(() => {
    jwtAuthAxios
      .get(`master/helper?party=1`)
      .then((res) => {
        setUserParty(res.data?.data?.PARTY || []);
      })
      .catch((e) => {
        swal.fire({
          icon: "error",
          text: "Internal server Error",
        });
      });
  }, []);

  const AddtoBasketHandler = async () => {
    setBLOADER(true);
    await jwtAuthAxios
      .post(`user/basket/add`, {
        stone_id: SelectedStone,
        party: userSelectedParty,
        type: "parcel",
      })
      .then((res) => {
        swal.fire({
          icon: "success",
          text: res.data.message,
        });
        navigate("/mybasket");
      })
      .catch((e) => {
        swal.fire({
          icon: "error",
          text: "Internal server Error",
        });
      })
      .finally(() => setBLOADER(false));
  };
  // const isMobile = isMobileDevice();
  const isMobile = isMobileDevice();
  useEffect(() => {
    // alert(isMobile)
    let excelmap =ResultData.map(_ =>({
      STONE:_['FL_SUB_LOT'],
      CARATS:_['FL_CARATS'],
      COLOR:_['FL_COLOR'],
      MAIN_LOT:_['FL_MAIN_LOT'],
      CLARITY:_['FL_CLARITY']
    }))
    setSelectedStoneData(excelmap)
    setRightComp(
      <>
        {isMobile ? (
          <>
            <Tooltip title={`(${ResultData?.length})Modify Search`}>
              <Fab
                size="small"
                variant="outlined"
                onClick={() => fallBack(false)}
                sx={{
                  display: "flex",
                  margin: "5px auto",
                  mt: 3,
                  ml: "auto !important",
                }}
                color="primary"
              >
                <FilterAltIcon />
              </Fab>
            </Tooltip>
          </>
        ) : (
          <>
            <Button
              sx={{ ml: "auto !important" }}
              onClick={() => fallBack(false)}
              variant="outlined"
              startIcon={<FilterAltIcon fontSize={"30px"} />}
              color="primary"
            >
              Modify Search ({ResultData?.length})
            </Button>
          </>
        )}
        <ExcelGenerateAdmin text={"Excel"} data={SelectedStoneData} />
      </>
    );
  }, [ResultData, SelectedStone]);

  return (
    <>
      {Array.isArray(userParty) && (
        <Stack
          direction={"row"}
          style={{ justifyContent: "end" }}
          spacing={{ xs: 1, sm: 2, md: 4 }}
          sx={{ mb: 3 }}
        >
          {/* <Button onClick={()=>fallBack(false)} variant="outlined" startIcon={<FilterAltIcon  fontSize={'30px'} />}  color='primary'>{!isMobile && 'Modify Search'} ({ResultData?.length})</Button>
        <ExcelGenerateAdmin  text={!isMobile ?'Excel':'E'} data={SelectedStoneData} /> */}
          {/* <ExcelGenerateForSearch  data={SelectedStoneData} /> */}
          <FormControl
            fullWidth
            sx={{ m: 1, maxWidth: "350px", width: "100%" }}
            size="small"
          >
            <InputLabel id="demo-select-small">Party</InputLabel>
            <Select
              labelId="demo-select-small"
              label="Party"
              onChange={(event) => setUserSelectedParty(event.target.value)}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {userParty.map((party) => (
                <MenuItem value={party.FL_PARTY_CODE}>
                  {party.FL_PARTY_NAME}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {/* {Array.isArray(userParty) && <Autocomplete
          disablePortal
          id="combo-box-demo"
          value={(option) => option.FL_PARTY_CODE}
          getOptionLabel={(option) => option.FL_PARTY_NAME}
          options={userParty}
          sx={{width: 300}}
          onChange={(e)=>console.log(e.target.value)}
          renderInput={(params) => <TextField {...params} label="Select Party"/>}
      />} */}
          <LoadingButton
            loading={BLOADER}
            variant="contained"
            disabled={!SelectedStone.length > 0 || !userSelectedParty}
            onClick={AddtoBasketHandler}
            sx={{ display: "flex", margin: "0 0px 22px auto" }}
            startIcon={<ShoppingCartCheckoutSharpIcon />}
            color="primary"
          >
            {!isMobile && "Add To Basket"}
          </LoadingButton>
        </Stack>
      )}
      <TableContainer component={Paper} className="result-table">
        {Array.isArray(ResultData) && ResultData.length > 0 ? (
          <DataGrid
            rows={ResultData || []}
            columns={columns}
            pageSize={5}
            // apiRef={apiRef}
            density="compact"
            getRowId={(row) => row.FL_SUB_LOT}
            rowsPerPageOptions={[50, 100, 200]}
            sx={{ p: 0, fontSize: "16px" }}
            onRowSelectionModelChange={(e) => setSelectedStone(e)}
            checkboxSelection
            // disableRowSelectionOnClick
          />
        ) : (
          <NoDataPlaceholder />
        )}
      </TableContainer>
    </>
  );
};

const JewelryResultView = ({ setRightComp, ResultData, fallBack }) => {
  const [userParty, setUserParty] = useState(null);
  const [userSelectedParty, setUserSelectedParty] = useState(null);
  const [BLOADER, setBLOADER] = useState(false);
  const [SelectedStone, setSelectedStone] = useState([]);
  const swal = useSwalWrapper();
  const navigate = useNavigate();
  const { menuObject } = useJumboAuth();

  const columns = [
    { field: "FL_ITEM_CODE", flex: 1, headerName: "Item Code" },
    { field: "FL_CATGORY", flex: 1, headerName: "Catgory" },
    { field: "FL_QUALITY", flex: 1, headerName: "Quality" },
    { field: "FL_GROSS_WT", flex: 1, headerName: "Gross Wt" },
    { field: "FL_NET_WT", flex: 1, headerName: "Net Wt" },
    {
      field: "FL_DIAM_PCS",
      flex: 1,
      headerName: "Diamond Pcs",
    },
    {
      field: "FL_DIAM_CTS",
      flex: 1,
      headerName: "Diamond Cts",
    },
    {
      field: "FL_STATUS",
      flex: 1,
      headerName: "Status",
    },
    {
      field: "FL_SALE_AMT",
      flex: 1,
      headerName: "Sale Amount",
    },
  ];

  useEffect(() => {
    jwtAuthAxios
      .get(`master/helper?party=1`)
      .then((res) => {
        setUserParty(res.data?.data?.PARTY || []);
      })
      .catch((e) => {
        swal.fire({
          icon: "error",
          text: "Internal server Error",
        });
      });
  }, []);

  const AddtoBasketHandler = async () => {
    setBLOADER(true);
    await jwtAuthAxios
      .post(`user/basket/add`, {
        stone_id: SelectedStone,
        party: userSelectedParty,
        type: "jewel",
      })
      .then((res) => {
        swal.fire({
          icon: "success",
          text: res.data.message,
        });
        navigate("/mybasket");
      })
      .catch((e) => {
        swal.fire({
          icon: "error",
          text: "Internal server Error",
        });
      })
      .finally(() => setBLOADER(false));
  };

  const isMobile = isMobileDevice();

  useEffect(() => {
    setRightComp(
      <>
        {isMobile ? (
          <>
            <Tooltip title={`(${ResultData?.length})Modify Search`}>
              <Fab
                size="small"
                variant="outlined"
                onClick={() => fallBack(false)}
                sx={{
                  display: "flex",
                  margin: "5px auto",
                  mt: 3,
                  ml: "auto !important",
                }}
                color="primary"
              >
                <FilterAltIcon />
              </Fab>
            </Tooltip>
          </>
        ) : (
          <>
            <Button
              sx={{ ml: "auto !important" }}
              onClick={() => fallBack(false)}
              variant="outlined"
              startIcon={<FilterAltIcon fontSize={"30px"} />}
              color="primary"
            >
              Modify Search ({ResultData?.length})
            </Button>
          </>
        )}
      </>
    );
  }, [ResultData]);

  const CustomToolbar = () => {
    return (
      <GridToolbarContainer>
        <GridToolbarExport printOptions={{ disableToolbarButton: true }} />
      </GridToolbarContainer>
    );
  };
  return (
    <>
      {Array.isArray(userParty) && (
        <Stack
          direction={"row"}
          style={{ justifyContent: "end" }}
          spacing={{ xs: 1, sm: 2, md: 4 }}
          sx={{ mb: 3 }}
        >
          <FormControl
            fullWidth
            sx={{ m: 1, maxWidth: "350px", width: "100%" }}
            size="small"
          >
            <InputLabel id="demo-select-small">Party</InputLabel>
            <Select
              labelId="demo-select-small"
              label="Party"
              onChange={(event) => setUserSelectedParty(event.target.value)}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {userParty.map((party) => (
                <MenuItem key={party.FL_PARTY_CODE} value={party.FL_PARTY_CODE}>
                  {party.FL_PARTY_NAME}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <LoadingButton
            loading={BLOADER}
            variant="contained"
            disabled={!SelectedStone.length > 0 || !userSelectedParty}
            onClick={AddtoBasketHandler}
            sx={{ display: "flex", margin: "0 0px 22px auto" }}
            startIcon={<ShoppingCartCheckoutSharpIcon />}
            color="primary"
          >
            {!isMobile && "Add To Basket"}
          </LoadingButton>
        </Stack>
      )}
      <TableContainer component={Paper} className="result-table">
        {Array.isArray(ResultData) && ResultData?.length > 0 ? (
          <DataGrid
            rows={ResultData || []}
            columns={columns}
            pageSize={5}
            // apiRef={apiRef}
            density="compact"
            getRowId={(row) => row?.FL_ITEM_CODE}
            rowsPerPageOptions={[50, 100, 200]}
            sx={{ p: 0, fontSize: "16px" }}
            onRowSelectionModelChange={(e) => setSelectedStone(e)}
            checkboxSelection
            slots={{
              toolbar: CustomToolbar,
            }}
          />
        ) : (
          <NoDataPlaceholder />
        )}
      </TableContainer>
    </>
  );
};
// function ParcelShapeList() {
//   return 'bulk'
// }
export default function StoneSearch() {
  const [RightComp, setRightComp] = useState(null);
  const [searchType, setSearchType] = useState("single");

  const isMobile = isMobileDevice();

  return (
    <>
      <Stack direction={"row"} sx={{ mb: 3, pt: 0 }} spacing={2}>
        {!isMobile ? (
          <Button
            startIcon={<DiamondIcon />}
            variant={searchType == "single" ? "contained" : "outlined"}
            onClick={() => setSearchType("single")}
          >
            Polish Certified
          </Button>
        ) : (
          <Tooltip title="Polish certified">
            <Button
              variant={searchType == "single" ? "contained" : "outlined"}
              onClick={() => setSearchType("single")}
            >
              <DiamondIcon />
            </Button>
          </Tooltip>
        )}
        {!isMobile ? (
          <Button
            startIcon={
              <svg
                width="16"
                height="14"
                className="btn-svg"
                viewBox="0 0 750 750"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M375 0C167.9 0 0 167.9 0 375C0 582.1 167.9 750 375 750C582.1 750 750 582.1 750 375C750 167.9 582.1 0 375 0ZM375 25C567.988 25 725 182.012 725 375H25C25 182.012 182.012 25 375 25Z"
                  fill="#7C8689"
                />
              </svg>
              // <img
              //   src="/images/svgs/Polish Parcel.svg"
              //   style={{ width: "30px", height: "30px", stroke: "#315372" }}
              // />
            }
            variant={searchType == "bulk" ? "contained" : "outlined"}
            onClick={() => setSearchType("bulk")}
          >
            {!isMobile && "Polish Parcel"}
          </Button>
        ) : (
          <Tooltip title="Polish Parcel">
            <Button
              variant={searchType == "bulk" ? "contained" : "outlined"}
              onClick={() => setSearchType("bulk")}
            >
              {
                <svg
                  width="16"
                  height="14"
                  viewBox="0 0 750 750"
                  fill="none"
                  className="btn-svg"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M375 0C167.9 0 0 167.9 0 375C0 582.1 167.9 750 375 750C582.1 750 750 582.1 750 375C750 167.9 582.1 0 375 0ZM375 25C567.988 25 725 182.012 725 375H25C25 182.012 182.012 25 375 25Z"
                    fill="#7C8689"
                  />
                </svg>
              }
              {/* <img
                src="/images/svgs/Polish Parcel.svg"
                style={{ width: "30px", height: "30px", stroke: "#315372" }}
              /> */}
            </Button>
          </Tooltip>
        )}
        {!isMobile ? (
          <Button
            startIcon={
              // <img
              //   src="/images/svgs/jewely.svg"
              //   style={{ width: "30px", height: "30px", stroke: "#315372" }}
              // />
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 693 800"
                fill="none"
                className="btn-svg"
              >
                <path
                  d="M162.479 62.1786C165.143 64.8427 169.139 67.5053 173.134 67.5053C175.798 67.5053 178.461 66.174 179.793 66.174C186.453 62.1786 187.784 54.1878 183.789 47.5282L157.152 7.57403C153.157 0.914482 145.166 -0.416804 138.506 3.57862C133.18 7.57403 131.847 15.5649 135.842 22.2244L162.479 62.1786Z"
                  fill="#7C8689"
                />
                <path
                  d="M625.948 174.05C629.943 174.05 632.607 172.719 635.27 170.055L675.224 130.101C680.551 124.774 680.551 116.783 675.224 111.455C669.897 106.128 661.906 106.128 656.578 111.455L616.624 151.409C611.297 156.736 611.297 164.727 616.624 170.055C619.29 172.719 621.952 174.05 625.948 174.05Z"
                  fill="#7C8689"
                />
                <path
                  d="M49.2781 111.455C43.9514 106.128 35.9606 106.128 30.6323 111.455C25.3041 116.782 25.3056 124.773 30.6323 130.101L70.5865 170.055C73.2507 172.719 75.9132 174.05 79.9086 174.05C83.9041 174.05 86.5682 172.719 89.2308 170.055C94.5575 164.728 94.5575 156.737 89.2308 151.409L49.2781 111.455Z"
                  fill="#7C8689"
                />
                <path
                  d="M511.415 64.843C514.079 66.1743 516.742 67.5071 519.406 67.5071C523.401 67.5071 527.397 64.843 530.061 60.8476L556.698 20.8934C560.692 14.2338 559.36 6.24298 552.701 2.24756C546.041 -1.74786 538.05 -0.416573 534.055 6.24298L507.418 46.1972C503.424 52.8567 504.756 60.8476 511.415 64.843Z"
                  fill="#7C8689"
                />
                <path
                  d="M531.389 740.069C527.393 733.41 519.403 732.078 512.743 736.074C506.083 740.069 504.752 748.06 508.748 754.72L535.384 794.674C538.048 797.338 542.044 800 546.039 800C548.703 800 551.366 798.669 554.03 798.669C560.69 794.674 562.021 786.683 558.025 780.023L531.389 740.069Z"
                  fill="#7C8689"
                />
                <path
                  d="M57.2656 630.859L17.3114 670.813C11.9847 676.14 11.9847 684.131 17.3114 689.459C19.9756 692.123 22.6381 693.455 26.6336 693.455C30.629 693.455 33.2931 692.123 35.9557 689.459L75.9099 649.505C81.2366 644.178 81.2366 636.188 75.9099 630.859C70.5832 625.533 62.5923 625.533 57.2656 630.859Z"
                  fill="#7C8689"
                />
                <path
                  d="M621.953 630.859C616.627 625.533 608.636 625.533 603.308 630.859C597.981 636.186 597.981 644.177 603.308 649.505L643.262 689.459C645.926 692.123 648.588 693.455 652.584 693.455C656.579 693.455 659.243 692.123 661.906 689.459C667.233 684.133 667.233 676.142 661.906 670.813L621.953 630.859Z"
                  fill="#7C8689"
                />
                <path
                  d="M179.796 734.741C173.136 730.745 165.145 732.077 161.15 738.736L134.513 778.69C130.518 785.35 131.849 793.341 138.509 797.336C141.173 798.667 143.835 800 146.499 800C150.495 800 154.49 797.336 157.154 793.341L183.791 753.387C187.786 746.727 186.454 738.736 179.796 734.741Z"
                  fill="#7C8689"
                />
                <path
                  d="M346.267 67.5053C354.258 67.5053 359.584 62.1786 359.584 54.1878V14.2336C359.584 6.24272 354.258 0.916016 346.267 0.916016C338.276 0.916016 332.949 6.24272 332.949 14.2336V54.1878C332.949 62.1786 338.276 67.5053 346.267 67.5053Z"
                  fill="#7C8689"
                />
                <path
                  d="M346.267 733.409C338.276 733.409 332.949 738.736 332.949 746.727V786.681C332.949 794.672 338.276 799.998 346.267 799.998C354.258 799.998 359.584 794.672 359.584 786.681V746.727C359.586 738.736 354.258 733.409 346.267 733.409Z"
                  fill="#7C8689"
                />
                <path
                  d="M13.3175 333.868H53.2717C61.2626 333.868 66.5893 328.541 66.5893 320.55C66.5893 312.559 61.2626 307.232 53.2717 307.232H13.3175C5.32671 307.232 0 312.559 0 320.55C0 328.541 5.32671 333.868 13.3175 333.868Z"
                  fill="#7C8689"
                />
                <path
                  d="M53.2717 507.001C61.2626 507.001 66.5893 501.675 66.5893 493.684C66.5893 485.693 61.2626 480.366 53.2717 480.366H13.3175C5.32671 480.366 0 485.693 0 493.684C0 501.675 5.32671 507.001 13.3175 507.001H53.2717Z"
                  fill="#7C8689"
                />
                <path
                  d="M639.267 307.23C631.276 307.23 625.949 312.557 625.949 320.548C625.949 328.539 631.276 333.866 639.267 333.866H679.221C687.212 333.866 692.539 328.539 692.539 320.548C692.539 312.557 687.212 307.23 679.221 307.23H639.267Z"
                  fill="#7C8689"
                />
                <path
                  d="M679.221 480.366H639.267C631.276 480.366 625.949 485.693 625.949 493.684C625.949 501.675 631.276 507.001 639.267 507.001H679.221C687.212 507.001 692.539 501.675 692.539 493.684C692.539 485.693 687.212 480.366 679.221 480.366Z"
                  fill="#7C8689"
                />
                <path
                  d="M584.662 592.744V202.019C585.388 199.843 585.302 197.674 584.662 195.714V195.359L584.454 195.117C583.9 193.713 583.062 192.428 581.998 191.364L502.089 98.138C501.531 97.5793 500.903 97.0939 500.24 96.6522L498.094 94.1426H193.111L106.543 195.359V605.556L107.954 607.206C108.291 607.988 108.686 608.77 109.207 609.552L189.115 702.778C189.674 703.336 190.302 703.822 190.965 704.263L193.111 706.773H499.427L517.692 684.798L583.331 608.22C585.995 605.556 587.326 601.561 585.995 597.565C585.993 595.888 585.502 594.224 584.662 592.744ZM197.106 576.257L235.729 614.88L198.439 670.816L141.172 604.225L197.106 576.257ZM258.369 600.23L213.088 554.949V247.301L259.702 200.688H434.169L456.81 223.329L479.451 245.97V554.949L434.17 600.23H258.369ZM495.432 576.257L551.367 604.225L494.1 670.816L456.81 614.88L495.432 576.257ZM495.432 224.66L456.809 186.037L494.099 130.101L551.366 196.692L495.432 224.66ZM432.393 174.051H261.476L225.961 120.779H467.905L432.393 174.051ZM198.438 130.101L235.728 186.037L197.105 224.66L141.183 196.7L169.802 163.398L198.438 130.101ZM133.18 221.996L186.451 248.633V551.618L133.18 578.255V221.996ZM260.145 626.865H432.393L467.908 680.136H224.631L260.145 626.865ZM506.085 551.618V247.3L560.689 219.998V578.92L506.085 551.618Z"
                  fill="#7C8689"
                />
                <path
                  d="M438.165 441.744C438.165 399.126 392.884 376.486 391.551 376.486C379.565 368.495 372.906 360.504 371.574 349.849C367.579 327.208 387.556 299.24 395.547 289.918C399.542 285.923 400.873 279.263 396.878 273.936C392.883 268.61 386.223 265.945 380.896 268.61C375.57 269.941 253.043 319.219 253.043 440.413C253.043 492.353 294.328 533.639 346.269 533.639C398.211 533.639 439.498 492.353 438.165 441.744ZM346.27 507.002C308.98 507.002 279.68 477.703 279.68 440.411C279.68 379.149 318.303 339.194 350.266 316.553C346.27 327.208 343.606 340.526 346.27 353.843C350.266 372.489 360.921 387.138 380.898 399.124C380.898 399.124 412.861 415.106 412.861 440.41C412.861 477.703 383.562 507.002 346.27 507.002Z"
                  fill="#7C8689"
                />
              </svg>
            }
            variant={searchType == "jewelry" ? "contained" : "outlined"}
            onClick={() => setSearchType("jewelry")}
          >
            {!isMobile && "jewelry"}
          </Button>
        ) : (
          <Tooltip title="jewelry">
            <Button
              variant={searchType == "jewelry" ? "contained" : "outlined"}
              onClick={() => setSearchType("jewelry")}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 693 800"
                fill="none"
                className="btn-svg"
              >
                <path
                  d="M162.479 62.1786C165.143 64.8427 169.139 67.5053 173.134 67.5053C175.798 67.5053 178.461 66.174 179.793 66.174C186.453 62.1786 187.784 54.1878 183.789 47.5282L157.152 7.57403C153.157 0.914482 145.166 -0.416804 138.506 3.57862C133.18 7.57403 131.847 15.5649 135.842 22.2244L162.479 62.1786Z"
                  fill="#7C8689"
                />
                <path
                  d="M625.948 174.05C629.943 174.05 632.607 172.719 635.27 170.055L675.224 130.101C680.551 124.774 680.551 116.783 675.224 111.455C669.897 106.128 661.906 106.128 656.578 111.455L616.624 151.409C611.297 156.736 611.297 164.727 616.624 170.055C619.29 172.719 621.952 174.05 625.948 174.05Z"
                  fill="#7C8689"
                />
                <path
                  d="M49.2781 111.455C43.9514 106.128 35.9606 106.128 30.6323 111.455C25.3041 116.782 25.3056 124.773 30.6323 130.101L70.5865 170.055C73.2507 172.719 75.9132 174.05 79.9086 174.05C83.9041 174.05 86.5682 172.719 89.2308 170.055C94.5575 164.728 94.5575 156.737 89.2308 151.409L49.2781 111.455Z"
                  fill="#7C8689"
                />
                <path
                  d="M511.415 64.843C514.079 66.1743 516.742 67.5071 519.406 67.5071C523.401 67.5071 527.397 64.843 530.061 60.8476L556.698 20.8934C560.692 14.2338 559.36 6.24298 552.701 2.24756C546.041 -1.74786 538.05 -0.416573 534.055 6.24298L507.418 46.1972C503.424 52.8567 504.756 60.8476 511.415 64.843Z"
                  fill="#7C8689"
                />
                <path
                  d="M531.389 740.069C527.393 733.41 519.403 732.078 512.743 736.074C506.083 740.069 504.752 748.06 508.748 754.72L535.384 794.674C538.048 797.338 542.044 800 546.039 800C548.703 800 551.366 798.669 554.03 798.669C560.69 794.674 562.021 786.683 558.025 780.023L531.389 740.069Z"
                  fill="#7C8689"
                />
                <path
                  d="M57.2656 630.859L17.3114 670.813C11.9847 676.14 11.9847 684.131 17.3114 689.459C19.9756 692.123 22.6381 693.455 26.6336 693.455C30.629 693.455 33.2931 692.123 35.9557 689.459L75.9099 649.505C81.2366 644.178 81.2366 636.188 75.9099 630.859C70.5832 625.533 62.5923 625.533 57.2656 630.859Z"
                  fill="#7C8689"
                />
                <path
                  d="M621.953 630.859C616.627 625.533 608.636 625.533 603.308 630.859C597.981 636.186 597.981 644.177 603.308 649.505L643.262 689.459C645.926 692.123 648.588 693.455 652.584 693.455C656.579 693.455 659.243 692.123 661.906 689.459C667.233 684.133 667.233 676.142 661.906 670.813L621.953 630.859Z"
                  fill="#7C8689"
                />
                <path
                  d="M179.796 734.741C173.136 730.745 165.145 732.077 161.15 738.736L134.513 778.69C130.518 785.35 131.849 793.341 138.509 797.336C141.173 798.667 143.835 800 146.499 800C150.495 800 154.49 797.336 157.154 793.341L183.791 753.387C187.786 746.727 186.454 738.736 179.796 734.741Z"
                  fill="#7C8689"
                />
                <path
                  d="M346.267 67.5053C354.258 67.5053 359.584 62.1786 359.584 54.1878V14.2336C359.584 6.24272 354.258 0.916016 346.267 0.916016C338.276 0.916016 332.949 6.24272 332.949 14.2336V54.1878C332.949 62.1786 338.276 67.5053 346.267 67.5053Z"
                  fill="#7C8689"
                />
                <path
                  d="M346.267 733.409C338.276 733.409 332.949 738.736 332.949 746.727V786.681C332.949 794.672 338.276 799.998 346.267 799.998C354.258 799.998 359.584 794.672 359.584 786.681V746.727C359.586 738.736 354.258 733.409 346.267 733.409Z"
                  fill="#7C8689"
                />
                <path
                  d="M13.3175 333.868H53.2717C61.2626 333.868 66.5893 328.541 66.5893 320.55C66.5893 312.559 61.2626 307.232 53.2717 307.232H13.3175C5.32671 307.232 0 312.559 0 320.55C0 328.541 5.32671 333.868 13.3175 333.868Z"
                  fill="#7C8689"
                />
                <path
                  d="M53.2717 507.001C61.2626 507.001 66.5893 501.675 66.5893 493.684C66.5893 485.693 61.2626 480.366 53.2717 480.366H13.3175C5.32671 480.366 0 485.693 0 493.684C0 501.675 5.32671 507.001 13.3175 507.001H53.2717Z"
                  fill="#7C8689"
                />
                <path
                  d="M639.267 307.23C631.276 307.23 625.949 312.557 625.949 320.548C625.949 328.539 631.276 333.866 639.267 333.866H679.221C687.212 333.866 692.539 328.539 692.539 320.548C692.539 312.557 687.212 307.23 679.221 307.23H639.267Z"
                  fill="#7C8689"
                />
                <path
                  d="M679.221 480.366H639.267C631.276 480.366 625.949 485.693 625.949 493.684C625.949 501.675 631.276 507.001 639.267 507.001H679.221C687.212 507.001 692.539 501.675 692.539 493.684C692.539 485.693 687.212 480.366 679.221 480.366Z"
                  fill="#7C8689"
                />
                <path
                  d="M584.662 592.744V202.019C585.388 199.843 585.302 197.674 584.662 195.714V195.359L584.454 195.117C583.9 193.713 583.062 192.428 581.998 191.364L502.089 98.138C501.531 97.5793 500.903 97.0939 500.24 96.6522L498.094 94.1426H193.111L106.543 195.359V605.556L107.954 607.206C108.291 607.988 108.686 608.77 109.207 609.552L189.115 702.778C189.674 703.336 190.302 703.822 190.965 704.263L193.111 706.773H499.427L517.692 684.798L583.331 608.22C585.995 605.556 587.326 601.561 585.995 597.565C585.993 595.888 585.502 594.224 584.662 592.744ZM197.106 576.257L235.729 614.88L198.439 670.816L141.172 604.225L197.106 576.257ZM258.369 600.23L213.088 554.949V247.301L259.702 200.688H434.169L456.81 223.329L479.451 245.97V554.949L434.17 600.23H258.369ZM495.432 576.257L551.367 604.225L494.1 670.816L456.81 614.88L495.432 576.257ZM495.432 224.66L456.809 186.037L494.099 130.101L551.366 196.692L495.432 224.66ZM432.393 174.051H261.476L225.961 120.779H467.905L432.393 174.051ZM198.438 130.101L235.728 186.037L197.105 224.66L141.183 196.7L169.802 163.398L198.438 130.101ZM133.18 221.996L186.451 248.633V551.618L133.18 578.255V221.996ZM260.145 626.865H432.393L467.908 680.136H224.631L260.145 626.865ZM506.085 551.618V247.3L560.689 219.998V578.92L506.085 551.618Z"
                  fill="#7C8689"
                />
                <path
                  d="M438.165 441.744C438.165 399.126 392.884 376.486 391.551 376.486C379.565 368.495 372.906 360.504 371.574 349.849C367.579 327.208 387.556 299.24 395.547 289.918C399.542 285.923 400.873 279.263 396.878 273.936C392.883 268.61 386.223 265.945 380.896 268.61C375.57 269.941 253.043 319.219 253.043 440.413C253.043 492.353 294.328 533.639 346.269 533.639C398.211 533.639 439.498 492.353 438.165 441.744ZM346.27 507.002C308.98 507.002 279.68 477.703 279.68 440.411C279.68 379.149 318.303 339.194 350.266 316.553C346.27 327.208 343.606 340.526 346.27 353.843C350.266 372.489 360.921 387.138 380.898 399.124C380.898 399.124 412.861 415.106 412.861 440.41C412.861 477.703 383.562 507.002 346.27 507.002Z"
                  fill="#7C8689"
                />
              </svg>
              {/* <img
                src="/images/svgs/jewelry.svg"
                style={{ width: "30px", height: "30px", stroke: "#315372" }}
              /> */}
            </Button>
          </Tooltip>
        )}
        {RightComp}
        {/* <Button startIcon={<DiamondIcon />} variant={searchType != 'single' ? 'outlined' : 'contained'} onClick={() => setSearchType('single')}>{!isMobile &&'Polish Single'}</Button> */}
      </Stack>

      {searchType == "single" ? (
        <SingleShapeList setRightComp={setRightComp} RightComp={RightComp} />
      ) : searchType == "jewelry" ? (
        <Jewelry setRightComp={setRightComp} />
      ) : (
        <ParcelShapeList setRightComp={setRightComp} />
      )}
    </>
  );
}
StoneSearch.Modulename = "StoneSearch";
